<div class="tds-container-fluid">
    <div class="tds-row">
        <h2 class="tds-headline-02">Dealers e Gen</h2>
    </div>

    <div class="tds-row">
        <tds-table vertical-dividers="false" compact-design="false" responsive="true" no-min-width>
            <tds-table-toolbar filter>
                 <div slot="end" class="tds-u-flex tds-u-align-items-center tds-u-h-100 tds-u-gap1" style="margin-left: 8px;">
                    <tds-button variant="secondary" size="sm" title="Inserir Gerente">
                        <tds-icon slot="icon" class="tds-btn-icon" size="18px" name="plus"></tds-icon>
                    </tds-button>
                 </div>
            </tds-table-toolbar>
            <tds-table-header>
                <tds-header-cell cell-key="actions"></tds-header-cell>
                <tds-header-cell cell-key='usuario' cell-value='Usuário' sortable></tds-header-cell>
                <tds-header-cell cell-key='nome' cell-value='Nome' sortable></tds-header-cell>
                <tds-header-cell cell-key="actions"></tds-header-cell>
                <tds-header-cell cell-key="actions"></tds-header-cell>
            </tds-table-header>
            <tds-table-body>
                <tds-table-body-row>
                    <tds-body-cell cell-key="actions">
                        <div class="action-buttons" title="Excluir">
                            <tds-icon id="edit" name="cross" size="20px" style="cursor: pointer;" ></tds-icon>
                        </div>
                    </tds-body-cell>
                    <tds-body-cell cell-key="usuario">SSBADD</tds-body-cell>
                    <tds-body-cell cell-key="nome">ADILSON</tds-body-cell>
                    <tds-body-cell cell-key="actions">
                        <div class="action-buttons" title="Dealers">
                            <tds-icon id="edit" name="info" size="20px" style="cursor: pointer;" ></tds-icon>
                        </div>
                    </tds-body-cell>
                    <tds-body-cell cell-key="actions">
                        <div class="action-buttons" title="Adicionar Dealers">
                            <tds-icon id="edit" name="plus" size="20px" style="cursor: pointer;" ></tds-icon>
                        </div>
                    </tds-body-cell>
                </tds-table-body-row>
            </tds-table-body>
        </tds-table>
    </div>
</div>